import { ReactNode } from "react";
import { Box } from "@mui/material";

import SectionSeparator from "./SectionSeparator";

/**
 * One block of a form, cut the way the configuration dialogs cut theirs: a
 * rule, the title of what follows, then the controls on one line.
 */
const Section = ({
  title,
  subtitle,
  subtitleValues,
  children,
}: {
  title: string;
  subtitle?: string;
  subtitleValues?: Record<string, ReactNode>;
  children: ReactNode;
}) => (
  <Box>
    <SectionSeparator
      label={title}
      subLabel={subtitle}
      subLabelValues={subtitleValues}
      align="left"
    />
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default Section;
